import { ApplicationConfig, ErrorHandler, importProvidersFrom, provideZoneChangeDetection, APP_INITIALIZER, PLATFORM_ID } from '@angular/core';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';


// Other module imports
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { rootReducer } from './modals';
import { AuthenticationEffects } from './modals/Authentication/authentication.effects';
import { routes } from './app.routes';
import { provideRouter, Router } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BsDropdownConfig } from 'ngx-bootstrap/dropdown';
import { CustomToastComponent } from './shared/custom-toast/custom-toast.component';
import { ProfileEffect } from './modals/Profile/profile.effects';
import { RolesRecordEffects } from './modals/Roles/roles.effect';
import { DatePipe } from '@angular/common';
import { AccessRecordEffects } from './modals/Access/access.effect';
import { ManualssRecordEffects } from './modals/Manuals/manuals.effect';
import { ChangelogsRecordEffects } from './modals/Changelogs/changelogs.effect';
import { FaqsRecordEffects } from './modals/Faqs/faqs.effect';
import { SupportRequestsRecordEffects } from './modals/SupportRequests/support-requests.effect';
import { ClubsRecordEffects } from './modals/Clubs/clubs.effect';
import { ClubUserRecordEffects } from './modals/ClubUser/club-user.effect';
import { ChangelogVersionsRecordEffects } from './modals/ChangelogVersions/changelog-versions.effect';
import { UsersRecordEffects } from './modals/Users/users.effect';
import { ClubNotesRecordEffects } from './modals/ClubNotes/club-notes.effect';
import { ClubAttachmentRecordEffects } from './modals/ClubAttachment/club-attachment.effect';
import { ClubManagementRecordEffects } from './modals/ClubManagement/club-management.effect';
import { TaskCategoryRecordEffects } from './modals/TaskCategory/task-category.effect';
import { ClubLogsRecordEffects } from './modals/ClubLogs/club-logs.effect';
import { DashboardRecordEffects } from './modals/Dashboard/dashboard.effect';
import { DossierRecordEffects } from './modals/Dossier/dossier.effect';
import { DossierAttachmentRecordEffects } from './modals/DossierAttachment/dossier-attachment.effect';
import { CommunicationCategoryRecordEffects } from './modals/CommunicationCategory/communication-category.effect';
import { AgendaTaskRecordEffects } from './modals/AgendaTask/agenda-task.effect';
import { DossierLogsRecordEffects } from './modals/DossierLogs/dossier-logs.effect';
import { DossierCategoryRecordEffects } from './modals/DossierCategory/dossier-category.effect';
import { DossierNotesRecordEffects } from './modals/DossierNotes/dossier-notes.effect';
import { SentEmailsRecordEffects } from './modals/SentEmails/sent-emails.effect';
import { SentCorrespondencesRecordEffects } from './modals/SentCorrespondence/sent-correspondence.effect';
import { EmailTemplateRecordEffects } from './modals/EmailTemplate/email-template.effect';
import { WhatsappTemplateRecordEffects } from './modals/WhatsappTemplate/whatsapp-template.effect';
import { LetterTemplateRecordEffects } from './modals/LetterTemplate/letter-template.effect';
import { SmsTemplateRecordEffects } from './modals/SmsTemplate/sms-template.effect';
import { SeasonsRecordEffects } from './modals/Seasons/seasons.effect';
import { MemberRecordEffects } from './modals/Member/member.effect';
import { MemberAttachmentRecordEffects } from './modals/MemberAttachment/member-attachment.effect';
import { MemberNotesRecordEffects } from './modals/MemberNotes/member-notes.effect';
import { MemberLogsRecordEffects } from './modals/MemberLogs/member-logs.effect';
import { WorkflowRestrictionsRecordEffects } from './modals/WorkflowRestrictions/workflow-restrictions.effect';
import { WorkflowSettingsRecordEffects } from './modals/WorkflowSettings/workflow-settings.effect';
import { WorkflowEmailTemplateRecordEffects } from './modals/WorkflowEmailTemplate/workflow-email-template.effect';
import { WorkflowsRecordEffects } from './modals/Workflows/workflows.effect';
import { ClubCategoryRecordEffects } from './modals/ClubCategory/club-category.effect';
import { DossierWorkflowRecordEffects } from './modals/DossierWorkflow/dossier-workflow.effect';
import { ReportRecordEffects } from './modals/Report/report.effect';
import { DossierInvoicesRecordEffects } from './modals/DossierInvoice/dossier-invoice.effect';
import { BulkToolsRecordEffects } from './modals/BulkTools/bulk-tools.effect';
import { ServiceFeeRecordEffects } from './modals/ServiceFee/service-fee.effect';
import { PrintlogsRecordEffects } from './modals/Printlogs/printlogs.effect';
import { BulkImportRecordEffects } from './modals/BulkImport/bulk-import.effect';
import { PaymentTypeRecordEffects } from './modals/PaymentType/payment-type.effect';
import { UserNotificationsRecordEffects } from './modals/UserNotifications/user-notifications.effect';
import { ContributieEmailTemplateRecordEffects } from './modals/ContributieEmailTemplate/contributie-email-template.effect';
import { PaymentArrangementRecordEffects } from './modals/PaymentArrangement/payment-arrangement.effect';
import { WorkflowLetterTemplateRecordEffects } from './modals/WorkflowLetterTemplate/workflow-letter-template.effect';
import { WorkflowFailedEmailRecordEffects } from './modals/WorkflowFailedEmail/workflow-failed-email.effect';
import { isPlatformBrowser } from '@angular/common';
import * as Sentry from '@sentry/angular';
import { environment } from 'src/environments/environment';
import { FailedEmailsRecordEffects } from './modals/FailedEmails/failed-emails.effect';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'fetch-lang/contributie_', '.json');
}

export function provideSentryStandalone(platformId: object) {
  // Prevent Sentry browser integrations from running on SSR/server
  if (!isPlatformBrowser(platformId)) return [];

  // Optional: only wire providers when Sentry is enabled
  if (environment.env === "local") return [];

  return [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ];
}

export const appConfig: ApplicationConfig = {
  providers: [
    DatePipe,
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes),
    provideStore(rootReducer),
    provideEffects(
      [
        AuthenticationEffects,
        RolesRecordEffects,
        AccessRecordEffects,
        ProfileEffect,
        ManualssRecordEffects,
        ChangelogsRecordEffects,
        FaqsRecordEffects,
        SupportRequestsRecordEffects,
        ClubsRecordEffects,
        ClubUserRecordEffects,
        ChangelogVersionsRecordEffects,
        UsersRecordEffects,
        ClubNotesRecordEffects,
        ClubAttachmentRecordEffects,
        ClubManagementRecordEffects,
        TaskCategoryRecordEffects,
        ClubLogsRecordEffects,
        DashboardRecordEffects,
        DossierRecordEffects,
        DossierAttachmentRecordEffects,
        CommunicationCategoryRecordEffects,
        AgendaTaskRecordEffects,
        DossierLogsRecordEffects,
        DossierCategoryRecordEffects,
        DossierNotesRecordEffects,
        SentEmailsRecordEffects,
        SentCorrespondencesRecordEffects,
        EmailTemplateRecordEffects,
        WhatsappTemplateRecordEffects,
        SmsTemplateRecordEffects,
        LetterTemplateRecordEffects,
        SeasonsRecordEffects,
        MemberRecordEffects,
        MemberAttachmentRecordEffects,
        MemberNotesRecordEffects,
        MemberLogsRecordEffects,
        WorkflowRestrictionsRecordEffects,
        WorkflowSettingsRecordEffects,
        WorkflowEmailTemplateRecordEffects,
        WorkflowsRecordEffects,
        ClubCategoryRecordEffects,
        DossierWorkflowRecordEffects,
        ReportRecordEffects,
        DossierInvoicesRecordEffects,
        BulkToolsRecordEffects,
        ServiceFeeRecordEffects,
        PrintlogsRecordEffects,
        BulkImportRecordEffects,
        PaymentTypeRecordEffects,
        UserNotificationsRecordEffects,
        ContributieEmailTemplateRecordEffects,
        PaymentArrangementRecordEffects,
        WorkflowLetterTemplateRecordEffects,
        WorkflowFailedEmailRecordEffects,
        FailedEmailsRecordEffects
      ]
    ),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient]
        }
      }),
      ToastrModule.forRoot({
        toastComponent: CustomToastComponent
      }),
    ),
    provideAnimations(),
    // provideToastr(),
    { provide: BsDropdownConfig, useValue: { isAnimated: true, autoClose: true } },
    {
      provide: 'SENTRY_PROVIDERS',
      useFactory: provideSentryStandalone,
      deps: [PLATFORM_ID],
    },
  ]
};

